import { cn } from '@talentmesh/ui/lib/utils';
import React from 'react';

interface TableToolbarProps extends React.HTMLAttributes<HTMLDivElement> {
    spacing?: number;
}

const TableToolbar = ({ children, className, ...props }: React.PropsWithChildren<TableToolbarProps>) => {
    return (
        <div
            className={cn('border-border flex h-16 cursor-auto flex-row items-center gap-2.5 border-b px-2', className)}
            data-cy="tableToolbar"
            {...props}
        >
            {children}
        </div>
    );
};

export default TableToolbar;
